import { render, staticRenderFns } from "./ListRole.vue?vue&type=template&id=39d55a0c&scoped=true"
import script from "./ListRole.vue?vue&type=script&lang=js"
export * from "./ListRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d55a0c",
  null
  
)

export default component.exports